import type { FC } from 'react';
import AdsHistoryPage from './AdsHistoryPage';

const ScalingHistoryByAdsPage: FC = () => (
  <AdsHistoryPage marketingProcess="scaling" embedded />
);

export default ScalingHistoryByAdsPage;
